export const OLD_APM_DIRTY_PORTFOLIO_RESPONSE = {
	success: true,
	errors: [
		{
			code: 'MODEL_IS_OVERRIDDEN_AT_BLK',
			message: 'no',
			details: 'The model is imported in BLK'
		},
		{
			code: 'MODEL_IS_MODIFIED_AT_SOURCE',
			message: 'no',
			details: 'The model has been modified at source since its last import'
		},
		{
			code: 'MODEL_IS_A_FIRST_TIME_IMPORT',
			message: 'no',
			details: 'The model is imported for first time '
		}
	],
	status: 'OK',
	response: {
		id: '529d304c-8074-459d-a9fa-fcce897e0989',
		description: 'QA-Automation Dirty6',
		type: 'PORTFOLIO',
		subType: 'THIRD_PARTY_MODEL',
		children: [
			{
				identifier: 'ENVESTNET_HANDLE@0100000AEEN0112265725HK2LGVDPSTU3PRSII3IKZ5SOIQBHJGA6FQKLCIAHPRM62U4UJHIEA====',
				identifierType: 'CUSTOM',
				weight: 5.25,
				allData: {
					date: 1593017593238,
					positionType: 'INVALID',
					'@type': '_bws.user.WebUserData',
					identifierType: 'CUSTOM',
					type: 'PORTFOLIO_POSITION',
					currentUserIsOwner: true,
					score: 1,
					dateCreated: 1593017602737,
					dateLastModified: 1593017602737,
					userEmail: 'rrandall@bfm.com',
					owner: {
						userPlatformId: '3225081',
						userEmail: 'rrandall@bfm.com',
						userId: 'rrandall@bfm.com'
					},
					identifier: 'ENVESTNET_HANDLE@0100000AEEN0112265725HK2LGVDPSTU3PRSII3IKZ5SOIQBHJGA6FQKLCIAHPRM62U4UJHIEA====',
					trackingType: 'userData',
					userPlatformId: '3225081',
					childFlag: true,
					level: 1,
					updateUserId: 'rrandall@bfm.com',
					weight: 5.25,
					userId: 'rrandall@bfm.com',
					updateTimestamp: 1593017603104,
					parentId: '529d304c-8074-459d-a9fa-fcce897e0989',
					parentType: 'PORTFOLIO',
					otherIdentifiers: [
						{
							identifier: 'H32673342',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'CUSIP'
						},
						{
							identifier: '529d304c-8074-459d-a9fa-fcce897e0989',
							customIdentifierType: 'ENVESTNET_HANDLE',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'CUSTOM'
						},
						{
							identifier: 'H32673342',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'TICKER'
						}
					],
					originPlatform: {
						name: '0898 Vanguard Total Bnd Mrkt Ind F Adm',
						type: 'SECURITY'
					},
					userTrackingId: '2555854',
					uniqueId: 'eb508d1d-6a39-4d7c-823f-d5cbbfe59992'
				}
			},
			{
				identifier: 'IVV@464287200@US4642872000',
				identifierType: 'SECURITY_ID',
				weight: 15.83,
				allData: {
					date: 1593017593238,
					positionType: 'VALID',
					'@type': '_bws.user.WebUserData',
					identifierType: 'SECURITY_ID',
					type: 'PORTFOLIO_POSITION',
					currentUserIsOwner: true,
					score: 1,
					dateCreated: 1593017602737,
					dateLastModified: 1593017602737,
					userEmail: 'rrandall@bfm.com',
					commonIdentifier: 'IVV@464287200@US4642872000',
					owner: {
						userPlatformId: '3225081',
						userEmail: 'rrandall@bfm.com',
						userId: 'rrandall@bfm.com'
					},
					identifier: 'IVV@464287200@US4642872000',
					trackingType: 'userData',
					userPlatformId: '3225081',
					childFlag: true,
					level: 1,
					updateUserId: 'rrandall@bfm.com',
					weight: 15.83,
					userId: 'rrandall@bfm.com',
					updateTimestamp: 1593017603103,
					parentId: '529d304c-8074-459d-a9fa-fcce897e0989',
					parentType: 'PORTFOLIO',
					commonIdentifierType: 'SECURITY_ID',
					otherIdentifiers: [
						{
							identifier: 'IVV',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'TICKER'
						},
						{
							identifier: '0100000AEEN01112384HMJEGBS55DXNO7PUUUQQMG5B3RMF3DDTGCID24QCMO2XC5Y57ZOSA====',
							customIdentifierType: 'ENVESTNET_HANDLE',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'CUSTOM'
						},
						{
							identifier: '464287200',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'CUSIP'
						}
					],
					originPlatform: {
						name: 'iShares Core S&P 500',
						type: 'SECURITY'
					},
					userTrackingId: '2555854',
					uniqueId: '0c13dc2d-4fd5-4de9-82d8-5cef270d0adb'
				}
			},
			{
				identifier: 'WFC@949746101@US9497461015',
				identifierType: 'SECURITY_ID',
				weight: 3.17,
				allData: {
					date: 1593017593238,
					positionType: 'VALID',
					'@type': '_bws.user.WebUserData',
					identifierType: 'SECURITY_ID',
					type: 'PORTFOLIO_POSITION',
					currentUserIsOwner: true,
					score: 1,
					dateCreated: 1593017602737,
					dateLastModified: 1593017602737,
					userEmail: 'rrandall@bfm.com',
					commonIdentifier: 'WFC@949746101@US9497461015',
					owner: {
						userPlatformId: '3225081',
						userEmail: 'rrandall@bfm.com',
						userId: 'rrandall@bfm.com'
					},
					identifier: 'WFC@949746101@US9497461015',
					trackingType: 'userData',
					userPlatformId: '3225081',
					childFlag: true,
					level: 1,
					updateUserId: 'rrandall@bfm.com',
					weight: 3.17,
					userId: 'rrandall@bfm.com',
					updateTimestamp: 1593017603103,
					parentId: '529d304c-8074-459d-a9fa-fcce897e0989',
					parentType: 'PORTFOLIO',
					commonIdentifierType: 'SECURITY_ID',
					otherIdentifiers: [
						{
							identifier: 'WFC',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'TICKER'
						},
						{
							identifier: '949746101',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'CUSIP'
						},
						{
							identifier: '0100000AEEN011392HGKCB5KFN2CLM4SSTFNKDT56E2IERFXXQ42B4RS5BTUOASHVSZ3UQ====',
							customIdentifierType: 'ENVESTNET_HANDLE',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'CUSTOM'
						}
					],
					originPlatform: { name: 'Wells Fargo & Co', type: 'SECURITY' },
					userTrackingId: '2555854',
					uniqueId: '25f33206-d18c-4910-90a2-33ec012e8d69'
				}
			},
			{
				identifier: 'ADBE@00724F101@US00724F1012',
				identifierType: 'SECURITY_ID',
				weight: 6.33,
				allData: {
					date: 1593017593238,
					positionType: 'VALID',
					'@type': '_bws.user.WebUserData',
					identifierType: 'SECURITY_ID',
					type: 'PORTFOLIO_POSITION',
					currentUserIsOwner: true,
					score: 1,
					dateCreated: 1593017602737,
					dateLastModified: 1593017602737,
					userEmail: 'rrandall@bfm.com',
					commonIdentifier: 'ADBE@00724F101@US00724F1012',
					owner: {
						userPlatformId: '3225081',
						userEmail: 'rrandall@bfm.com',
						userId: 'rrandall@bfm.com'
					},
					identifier: 'ADBE@00724F101@US00724F1012',
					trackingType: 'userData',
					userPlatformId: '3225081',
					childFlag: true,
					level: 1,
					updateUserId: 'rrandall@bfm.com',
					weight: 6.33,
					userId: 'rrandall@bfm.com',
					updateTimestamp: 1593017603103,
					parentId: '529d304c-8074-459d-a9fa-fcce897e0989',
					parentType: 'PORTFOLIO',
					commonIdentifierType: 'SECURITY_ID',
					otherIdentifiers: [
						{
							identifier: '00724F101',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'CUSIP'
						},
						{
							identifier: '0100000AEEN01184H3RGUNC4FAMGA2FOSIKLKTCJPH3JNJ5EANWU5CNZPKRB3ONWK2KCQ====',
							customIdentifierType: 'ENVESTNET_HANDLE',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'CUSTOM'
						},
						{
							identifier: 'ADBE',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'TICKER'
						}
					],
					originPlatform: { name: 'Adobe Systems Inc', type: 'SECURITY' },
					userTrackingId: '2555854',
					uniqueId: '31855e72-c188-4040-a012-139ea15a04a2'
				}
			},
			{
				identifier: 'CASH-USD@XUSD00000@',
				identifierType: 'SECURITY_ID',
				weight: 0.79,
				allData: {
					date: 1593017593238,
					positionType: 'VALID',
					'@type': '_bws.user.WebUserData',
					identifierType: 'SECURITY_ID',
					type: 'PORTFOLIO_POSITION',
					currentUserIsOwner: true,
					score: 1,
					dateCreated: 1593017602737,
					dateLastModified: 1593017602737,
					userEmail: 'rrandall@bfm.com',
					commonIdentifier: 'CASH-USD@XUSD00000@',
					owner: {
						userPlatformId: '3225081',
						userEmail: 'rrandall@bfm.com',
						userId: 'rrandall@bfm.com'
					},
					identifier: 'CASH-USD@XUSD00000@',
					trackingType: 'userData',
					userPlatformId: '3225081',
					childFlag: true,
					level: 1,
					updateUserId: 'rrandall@bfm.com',
					weight: 0.79,
					userId: 'rrandall@bfm.com',
					updateTimestamp: 1593017603103,
					parentId: '529d304c-8074-459d-a9fa-fcce897e0989',
					parentType: 'PORTFOLIO',
					commonIdentifierType: 'SECURITY_ID',
					otherIdentifiers: [
						{
							identifier: '0100000AEEN01154570HZJZVYB336BOW3FTTGDP4VUJ7VFJ3UIF2I3PXD5GNXAXOWG3YLETA====',
							customIdentifierType: 'ENVESTNET_HANDLE',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'CUSTOM'
						},
						{
							identifier: 'CASH-USD',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'TICKER'
						},
						{
							identifier: 'CASH-USD',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'CUSIP'
						}
					],
					originPlatform: { name: 'Cash', type: 'ASSET_CLASS' },
					userTrackingId: '2555854',
					uniqueId: '92b075e2-e221-4c37-a33f-c1a9d6602e77'
				}
			},
			{
				identifier: 'ENVESTNET_HANDLE@0100000AEEN01198677HVOIYLHVLOOZUFVOOC37QXCP4ANF56ICXCJR44YHWHYIWU4FISHVQ====',
				identifierType: 'CUSTOM',
				weight: 15.0,
				allData: {
					date: 1593017593238,
					positionType: 'INVALID',
					'@type': '_bws.user.WebUserData',
					identifierType: 'CUSTOM',
					type: 'PORTFOLIO_POSITION',
					currentUserIsOwner: true,
					score: 1,
					dateCreated: 1593017602737,
					dateLastModified: 1593017602737,
					userEmail: 'rrandall@bfm.com',
					owner: {
						userPlatformId: '3225081',
						userEmail: 'rrandall@bfm.com',
						userId: 'rrandall@bfm.com'
					},
					identifier: 'ENVESTNET_HANDLE@0100000AEEN01198677HVOIYLHVLOOZUFVOOC37QXCP4ANF56ICXCJR44YHWHYIWU4FISHVQ====',
					trackingType: 'userData',
					userPlatformId: '3225081',
					childFlag: true,
					level: 1,
					updateUserId: 'rrandall@bfm.com',
					weight: 15,
					userId: 'rrandall@bfm.com',
					updateTimestamp: 1593017603103,
					parentId: '529d304c-8074-459d-a9fa-fcce897e0989',
					parentType: 'PORTFOLIO',
					otherIdentifiers: [
						{
							identifier: '0100000AEEN01198677HVOIYLHVLOOZUFVOOC37QXCP4ANF56ICXCJR44YHWHYIWU4FISHVQ====',
							customIdentifierType: 'ENVESTNET_HANDLE',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'CUSTOM'
						},
						{
							identifier: 'BD-IPB',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'TICKER'
						}
					],
					originPlatform: {
						name: 'Inflation-Protected Bond',
						type: 'ASSET_CLASS'
					},
					userTrackingId: '2555854',
					uniqueId: 'dbb818f6-d949-4119-9f2c-e967e3f49d88'
				}
			},
			{
				identifier: 'AGG@464287226@US4642872265',
				identifierType: 'SECURITY_ID',
				weight: 31.66,
				allData: {
					date: 1593017593238,
					positionType: 'VALID',
					'@type': '_bws.user.WebUserData',
					identifierType: 'SECURITY_ID',
					type: 'PORTFOLIO_POSITION',
					currentUserIsOwner: true,
					score: 1,
					dateCreated: 1593017602737,
					dateLastModified: 1593017602737,
					userEmail: 'rrandall@bfm.com',
					commonIdentifier: 'AGG@464287226@US4642872265',
					owner: {
						userPlatformId: '3225081',
						userEmail: 'rrandall@bfm.com',
						userId: 'rrandall@bfm.com'
					},
					identifier: 'AGG@464287226@US4642872265',
					trackingType: 'userData',
					userPlatformId: '3225081',
					childFlag: true,
					level: 1,
					updateUserId: 'rrandall@bfm.com',
					weight: 31.66,
					userId: 'rrandall@bfm.com',
					updateTimestamp: 1593017603103,
					parentId: '529d304c-8074-459d-a9fa-fcce897e0989',
					parentType: 'PORTFOLIO',
					commonIdentifierType: 'SECURITY_ID',
					otherIdentifiers: [
						{
							identifier: '0100000AEEN01114905HGK3WGDXZP7NJFE5XHVRNWEPEVQ6BZLPTN4KTLCOSFF76AOPQCAOA====',
							customIdentifierType: 'ENVESTNET_HANDLE',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'CUSTOM'
						},
						{
							identifier: 'AGG',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'TICKER'
						},
						{
							identifier: '464287226',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'CUSIP'
						}
					],
					originPlatform: {
						name: 'iShares Core US Aggregate Bond',
						type: 'SECURITY'
					},
					userTrackingId: '2555854',
					uniqueId: 'f4b83294-35c8-427d-b87b-4be789f891fa'
				}
			},
			{
				identifier: 'CASH-USD@XUSD00000@',
				identifierType: 'SECURITY_ID',
				weight: 26.39,
				allData: {
					date: 1593017593238,
					positionType: 'VALID',
					'@type': '_bws.user.WebUserData',
					identifierType: 'SECURITY_ID',
					type: 'PORTFOLIO_POSITION',
					currentUserIsOwner: true,
					score: 1,
					dateCreated: 1593017602737,
					dateLastModified: 1593017602737,
					userEmail: 'rrandall@bfm.com',
					commonIdentifier: 'CASH-USD@XUSD00000@',
					owner: {
						userPlatformId: '3225081',
						userEmail: 'rrandall@bfm.com',
						userId: 'rrandall@bfm.com'
					},
					identifier: 'CASH-USD@XUSD00000@',
					trackingType: 'userData',
					userPlatformId: '3225081',
					childFlag: true,
					level: 1,
					updateUserId: 'rrandall@bfm.com',
					weight: 26.39,
					userId: 'rrandall@bfm.com',
					updateTimestamp: 1593017603102,
					parentId: '529d304c-8074-459d-a9fa-fcce897e0989',
					parentType: 'PORTFOLIO',
					commonIdentifierType: 'SECURITY_ID',
					otherIdentifiers: [
						{
							identifier: '0100000AEEN01154570HZJZVYB336BOW3FTTGDP4VUJ7VFJ3UIF2I3PXD5GNXAXOWG3YLETA====',
							customIdentifierType: 'ENVESTNET_HANDLE',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'CUSTOM'
						},
						{
							identifier: 'CASH-USD',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'TICKER'
						},
						{
							identifier: 'CASH-USD',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'CUSIP'
						}
					],
					originPlatform: { name: 'Cash', type: 'ASSET_CLASS' },
					userTrackingId: '2555854',
					uniqueId: '359c2ac6-3127-496d-95dd-19c43f4e2823'
				}
			},
			{
				identifier: 'TIP@464287176@US4642871762',
				identifierType: 'SECURITY_ID',
				weight: 15.83,
				allData: {
					date: 1593017593238,
					positionType: 'SUBSTITUTED',
					'@type': '_bws.user.WebUserData',
					identifierType: 'SECURITY_ID',
					type: 'PORTFOLIO_POSITION',
					currentUserIsOwner: true,
					score: 1,
					mappedFrom: [
						'ENVESTNET_HANDLE@0100000AEEN01198677HVOIYLHVLOOZUFVOOC37QXCP4ANF56ICXCJR44YHWHYIWU4FISHVQ===='
					],
					dateCreated: 1593017602737,
					dateLastModified: 1593017602737,
					userEmail: 'rrandall@bfm.com',
					commonIdentifier: 'TIP@464287176@US4642871762',
					owner: {
						userPlatformId: '3225081',
						userEmail: 'rrandall@bfm.com',
						userId: 'rrandall@bfm.com'
					},
					identifier: 'TIP@464287176@US4642871762',
					trackingType: 'userData',
					userPlatformId: '3225081',
					childFlag: true,
					level: 1,
					updateUserId: 'rrandall@bfm.com',
					weight: 15.83,
					userId: 'rrandall@bfm.com',
					updateTimestamp: 1593017603102,
					parentId: '529d304c-8074-459d-a9fa-fcce897e0989',
					parentType: 'PORTFOLIO',
					commonIdentifierType: 'SECURITY_ID',
					userTrackingId: '2555854',
					uniqueId: '3c62a0c6-b6a3-425c-a093-9762f6e597f6'
				}
			}
		],
		allData: {
			date: 1591953930525,
			'@type': 'com.bfm.webtools.api.domain.user.WebUserData',
			origin: 'partner',
			flags: {
				originContainsEditableModel: true,
				originContainsReallocatedSecurities: true,
				inputWithValues: false,
				originContainsFlattenedSleeves: true,
				isProcessed: true,
				originContainsUnmatchedSecurities: true,
				originContainsAssetClassSubstitutions: true
			},
			description: 'QA-Automation Dirty6',
			type: 'PORTFOLIO',
			currentUserIsOwner: true,
			score: 1,
			parentFlag: true,
			dateCreated: 1591953930525,
			dateLastModified: 1593017602737,
			userEmail: 'rrandall@bfm.com',
			perms: {
				DELETE: ['webUserDataPerm@AdvisorPort'],
				SHARE: ['webUserDataPerm@AdvisorPort'],
				VIEW: ['webUserDataPerm@AdvisorPort']
			},
			owner: {
				userPlatformId: '3225081',
				userEmail: 'rrandall@bfm.com',
				userId: 'rrandall@bfm.com'
			},
			ssoIdp: 'envestnet',
			toolOrigin: 'partner',
			trackingType: 'userData',
			userPlatformId: '3225081',
			level: 0,
			updateUserId: 'rrandall@bfm.com',
			childCount: 9,
			userId: 'rrandall@bfm.com',
			updateTimestamp: 1593017603104,
			otherIdentifiers: [
				{
					identifier: '0100000AEEN015604925H7R6X5RXKJWV2AA27NFLPCMYBMPNSBEULLCNFDD43XT6MKOJF7KUQ====',
					customIdentifierType: 'ENVESTNET_HANDLE',
					'@type': '_bws.investments.IdentifierParam',
					identifierType: 'CUSTOM'
				}
			],
			subType: 'THIRD_PARTY_MODEL',
			originPlatform: {
				firm: 'BlackRock',
				dateImported: '1591953930505',
				programHandle: '0100000AEEN01613H3MJAZEPFRG6GLHUIJ76FX664I5JKQH6OH6I5XGYWSI3Z6KJBLQLA====',
				externalModelDateLastModified: '1593017573423',
				riskHandle: '0100000AOOP03320HXOOOM2GK72BTE3FUJEPOEZVUWZZCGO2LVNTG77RQNTU5YAYCRSZA====',
				platform: 'ENVESTNET'
			},
			userTrackingId: '2555854',
			uniqueId: '529d304c-8074-459d-a9fa-fcce897e0989',
			applications: ['partner', 'bfa']
		}
	},
	responseTimes: {
		root: {
			nodes: [
				{
					data: { getModelDetails: 2.044 },
					nodes: [
						{ data: { accessToken: 0.0 } },
						{
							data: { searchPortfolio: 0.615 },
							nodes: [{ data: { searchPortfolio: 0.614 } }]
						},
						{ data: { getPortfolioJson: 0.433 } }
					]
				}
			]
		}
	}
};
